'use strict';

import { sessionStorage } from '../util/storage';

var Sizzle = require('sizzle');
var VideoConfig = require('../config');
var Device = require('../util/device');
var Debug = require('../util/debug')('ios-native-cc');
import * as domUtils from '../util/dom';
import ErrorType from '../constants/error-type';
var VideoAttributes = require('../util/video-attributes');

var _sessionStorageKey = 'currentIOSChromecastStatus';
var _sessionStoragePlayerStateKey = 'currentIOSChromecastPlayerState';
var _sessionStorageDeviceName = 'currentIOSChromecastDeviceName';

/**
 * UI Classes
 */
var CLASSNAMES = {
	chromecast: 'svp_js-chromecast',
	preloadCountdown: 'svp_js-chromecast__preload__countdown',
	message: 'svp_js-chromecast__message',
	icon: 'svp_js-chromecast__icon',
	splash: 'svp_js-splash',
	svpUi: 'svp_js-ui'
};

var STATE_CLASS = {
	visible: 'svp_is--visible',
	loading: 'svp_is--loading',
	hidden: 'svp_is--hidden',
	forceHide: 'svp_is--force-hide',
	error: 'svp_is--error'
};


var MESSAGES = {
	Connecting: 'Ansluter till %s',
	Connected: 'Visas på %s',
	Loading: 'Laddar video på %s',
	Playing: 'Visas på %s'
};

/**
 * Chromecast status enum
 */
var CHROMECAST_STATUS = {
	Disconnected: 'Disconnected',
	Disconnecting: 'Disconnecting',
	Connecting: 'Connecting',
	Connected: 'Connected'
};

var CHROMECAST_PLAYER_STATE = {
	IDLE: 'idle',
	BUFFERING: 'buffering',
	LOADING: 'loading',
	PLAYING: 'playing',
	PAUSED: 'paused',
	UNKNOWN: 'unknown'
};

var STATUS_EVENT_METHOD = {
	SUSPEND: "didSuspendCast",
	ENDED: "didEndCast"
};

// var DEFAULT_VIDEO_PLAYLIST_ITEM = {
// 	videoId: '', /** @type {string} programVersionId */
// 	poster: '', /** @type {image} */
// 	startPosition: 0  /** @type {number} */
// };
//
// var DEFAULT_VIDEO_PLAYLIST = {
// 	autoplay: true,
// 	repeatMode: 'all', // titleModel.series ? 'off' : 'all',
// 	items: [/** @type {!DEFAULT_VIDEO_PLAYLIST_ITEM} */]
// };

var NAMESPACE = 'ios-native-cc';
function initialVideoData() {
	return {
		videoId: '',
		thumbnailImage: '',
		posterImage: '',
		position: 0,
		metadata: {}
	};
}


//chromecast bridge
window.IOSDeviceChromecastBridgeInitialChromecastDeviceName = window.IOSDeviceChromecastBridgeInitialChromecastDeviceName || null;
window.IOSDeviceChromecastBridgeInitialChromecastStatus = window.IOSDeviceChromecastBridgeInitialChromecastStatus || CHROMECAST_STATUS.Disconnected;
window.IOSDeviceChromecastBridge = window.IOSDeviceChromecastBridge || {
		CHROMECAST_STATUS: CHROMECAST_STATUS,

		setChromecastStatus: function (status) {
            sessionStorage.setItem(_sessionStorageKey, status);
		},

		setChromecastDeviceName: function (deviceName) {
            sessionStorage.setItem(_sessionStorageDeviceName, deviceName);
		},

		setChromecastPlayerState: function (playerState) {
            sessionStorage.setItem(_sessionStoragePlayerStateKey, playerState);
		},

		onChromecastPreload: function () {
            // empty
		},

		onChromecastTimeUpdate: function (currentTime) {
            // empty
		},

		getChromecastStatus: function () {
			return sessionStorage.getItem(_sessionStorageKey) || CHROMECAST_STATUS.Disconnected;
		},

		isChromecastConnected: function () {
			return sessionStorage.getItem(_sessionStorageKey) === CHROMECAST_STATUS.Connected;
		}
	};
// Use IOSDeviceChromecastBridgeInitialCastStatus as initial value for ChromecastStatus
window.IOSDeviceChromecastBridge.setChromecastDeviceName(window.IOSDeviceChromecastBridgeInitialChromecastDeviceName);
window.IOSDeviceChromecastBridge.setChromecastStatus(window.IOSDeviceChromecastBridgeInitialChromecastStatus);
window.IOSDeviceChromecastBridge.setChromecastPlayerState(CHROMECAST_PLAYER_STATE.IDLE);


//chromecast player plugin
module.exports = {
	create: function (api) {
		if ((Device.isIOS() && VideoConfig.isInNativeApp) === false) {
			//Debug('Device is not an iOS app');
			return;
		}

		var videoData = initialVideoData();
		var videoPlaylist;
		var storedPosition = 0;
        var _isPlaying = false;
        var _isLoading = false;
        var _isExternalUi = false;
        var _isPaused = false;
        var _internalLoadAndPlayEvent = false;

		function currentSessionStatus() {
            return sessionStorage.getItem(_sessionStorageKey);
		}

		function currentSessionDeviceName() {
            return sessionStorage.getItem(_sessionStorageDeviceName);
		}

		function currentSessionPlayState() {
            return sessionStorage.getItem(_sessionStoragePlayerStateKey);
		}

		var nativeBuffer = {
			eventList: [],
			purging: false,
			exec: function (event) {
				nativeBuffer.eventList.push(event);
				nativeBuffer.purgeEventList();
			},
			purgeEventList: function () {
				if(nativeBuffer.purging || nativeBuffer.eventList.length === 0) {
					return;
				}
				var nextEvent = nativeBuffer.eventList.shift();

				if(webkit &&
					webkit.messageHandlers &&
					webkit.messageHandlers.svpCallbackHandler &&
					webkit.messageHandlers.svpCallbackHandler.postMessage) {
					try {
						webkit.messageHandlers.svpCallbackHandler.postMessage(nextEvent);

						return;
					} catch(err) {
						Debug.error('Failed during postMessage', err);
					}
				}

				nativeBuffer.purging = true;
				setTimeout(function () {
					if(nextEvent) {
						window.location = nextEvent;
					}
					nativeBuffer.purging = false;
					nativeBuffer.purgeEventList();
				}, 100);
			}
		};

		var NativeDispatcher = {
			send: function (eventName, data) {
				if(eventName.indexOf('chromecast-') === -1) {
					eventName = 'chromecast-' + eventName;
				}

				var jsonURL = ['svtplay', eventName, encodeURIComponent(JSON.stringify(data))].join(':');
				nativeBuffer.exec(jsonURL);
			},
			load: function () {
				if (videoPlaylist) {
					Debug.log('Native.load withPlaylist', videoPlaylist);
					NativeDispatcher.send('loadplaylist', videoPlaylist);
				} else if (videoData.videoId !== '') {
					Debug.log('Native.load withVideodata', videoData);
					NativeDispatcher.send('load', videoData);
				} else {
					Debug.log('WARNING! Native.load with invalid data. Could happen if data changes occur during idle app mode');
				}
			},
			queueNextItem: function () {
				NativeDispatcher.send('queue-next-item');
			},
			controlsToggled: function (visible) {
				visible = visible || false;
				NativeDispatcher.send('controls', { visible: visible });
			}
		};

		var ccUi = {
			getElement: function (className) {
				return Sizzle('.' + (className ? className : CLASSNAMES.chromecast), api.element())[0];
			},
			build: function () {
				var chromecastElement = domUtils.fromString(
					'<div class="svp_ui-chromecast ' + CLASSNAMES.chromecast + ' ' + STATE_CLASS.hidden + '">\
						<div class="svp_ui-chromecast__dimmer">\
							<div class="svp_ui-chromecast__inner">\
								<div class="svp_ui-chromecast__icon ' + CLASSNAMES.icon + '"></div>\
								<div class="svp_ui-chromecast__message ' + CLASSNAMES.message + '">Ready to cast</div>\
								<div class="svp_ui-chromecast__preload ' + CLASSNAMES.preloadCountdown + '">\
									<div class="svp_ui-chromecast__preload__info">\
										<span class="svp_ui-chromecast__preload__text">Nästa avsnitt börjar om </span>\
										<span class="svp_ui-chromecast__preload__countdown">15 sekunder</span>\
									</div>\
									<button class="svp_ui-chromecast__preload__next-button">Spela nästa nu</button>\
								</div>\
							</div>\
						</div>\
					</div>'
				);

				api.element().appendChild(chromecastElement);

				var preloadButtonElement = this.getElement(CLASSNAMES.preloadCountdown);
				if (preloadButtonElement) {
					domUtils.addEvents(preloadButtonElement, 'click, touchend', function (e) {
						Debug('preload queue next item clicked');
						e.stopPropagation();
						ccUi.hidePreload();
						NativeDispatcher.queueNextItem();
					}, NAMESPACE);
				}
			},
			reset: function () {
				var preloadButtonElement = this.getElement(CLASSNAMES.preloadCountdown);
				if (preloadButtonElement) {
					domUtils.removeEvents(preloadButtonElement, 'click, touchend', NAMESPACE);
				}

				var chromecastElement = ccUi.getElement();
				if (chromecastElement) {
					api.element().removeChild(chromecastElement);
				}
				domUtils.removeClass(api.element(), STATE_CLASS.forceHide);
			},
			text: function (status) {
				var result = '';
				if (status === CHROMECAST_STATUS.Connected) {
					if(_isLoading) {
						// Show loading text
						result = MESSAGES.Loading;
					} else if(_isPlaying) {
						// Show playing text
						result = MESSAGES.Playing;
					} else {
						result = MESSAGES.Connected;
					}

				} else if (status === CHROMECAST_STATUS.Connecting) {
					result = MESSAGES.Connecting;
				}

				return result.replace('%s', currentSessionDeviceName() || 'din cast-enhet');
			},
			showIcon: function (status) {
				var ccIconElement = ccUi.getElement(CLASSNAMES.icon);
				if (!ccIconElement) {
					return;
				}
				if (status === CHROMECAST_STATUS.Connected && _isLoading) {
					domUtils.addClass(ccIconElement, STATE_CLASS.loading);
				} else if (status === CHROMECAST_STATUS.Connecting) {
					domUtils.addClass(ccIconElement, STATE_CLASS.loading);
				} else {
					domUtils.removeClass(ccIconElement, STATE_CLASS.loading);
				}
			},
			showPreload: function (secondsLeft) {
				var preloadElement = ccUi.getElement(CLASSNAMES.preload);
				if (preloadElement) {
					domUtils.addClass(preloadElement, STATE_CLASS.visible);
					var preloadCountdownElement = ccUi.getElement(CLASSNAMES.preloadCountdown);
					if(preloadCountdownElement) {
						preloadCountdownElement.innerHTML = secondsLeft + (secondsLeft === 1 ? ' sekund' : ' sekunder');
					}
				}
			},
			hidePreload: function () {
				var preloadElement = ccUi.getElement(CLASSNAMES.preload);
				if (preloadElement) {
					domUtils.removeClass(preloadElement, STATE_CLASS.visible);
				}
			},
			show: function (status) {
				var ccElement = ccUi.getElement();

				if (!ccElement) {
					ccUi.build();
					ccElement = ccUi.getElement();
				}
				var ccTextElement = ccUi.getElement(CLASSNAMES.message),
					splash = ccUi.getElement(CLASSNAMES.splash);

				// Set poster as background-cover-image
				ccElement.setAttribute('style', 'background-image: url(' + getPosterImage() + ');');

				// Force hide all UI elements when in Chromecast state
				domUtils.addClass(api.element(), STATE_CLASS.forceHide);
				if (splash) {
					domUtils.addClass(splash, STATE_CLASS.hidden);
				}

				this.showIcon(status);

				ccTextElement.innerHTML = this.text(status);
				domUtils.removeClass(ccElement, STATE_CLASS.hidden);
			},
			hide: function () {
				var ccElement = ccUi.getElement(),
					ccTextElement = ccUi.getElement(CLASSNAMES.message);

				if (!ccElement) {
					return;
				}

				ccElement.removeAttribute('style');

				Debug.log('hideUi');
				if (domUtils.hasClass(ccElement, STATE_CLASS.hidden) === false) {
					domUtils.addClass(ccElement, STATE_CLASS.hidden);
					ccTextElement.innerHTML = '';
				}
				domUtils.removeClass(api.element(), STATE_CLASS.forceHide);

			}
		};

		window.IOSDeviceChromecastBridge.getVideoPosition = function () {
			var pos = storedPosition;
			Debug.log('getting video position: %s', pos);

			return pos;
		};

		var oldSetStatus = window.IOSDeviceChromecastBridge.setChromecastStatus;
		window.IOSDeviceChromecastBridge.setChromecastStatus = function (status, customData) {
			var currStatus = currentSessionStatus();
			if (typeof (customData) === 'string') {
				try {
					customData = JSON.parse(customData);
					customData.videoId = customData.videoId || null;
					customData.position = customData.position || "";
					customData.eventMethod = customData.eventMethod || null; /** {@type STATUS_EVENT_METHOD } */
				} catch(e) {
					Debug.warn('setChromecastStatus: Could not parse customData: ' + customData);
					customData = {};
				}
			}
			_updateActivePlaylistVideoData(customData.videoId, customData.position);

			oldSetStatus(status);
			Debug.log('setting cc status to %s (old status = %s) isPlaying = %s, customData=', status, currStatus, _isPlaying, customData);
			if (status !== currStatus) {
				_handleStateUpdate(status, currStatus, customData);
			}
		};

		var oldSetDeviceName = window.IOSDeviceChromecastBridge.setChromecastDeviceName;
		window.IOSDeviceChromecastBridge.setChromecastDeviceName = function (deviceName) {
			if (deviceName !== currentSessionDeviceName()) {
				Debug.log('setting device name: ' + deviceName);
				oldSetDeviceName(deviceName);
				ccUi.show(currentSessionStatus());
			}
		};

		window.IOSDeviceChromecastBridge.onChromecastTimeUpdate = function (currentTime) {
			if (typeof (currentTime) === 'string') {
				try {
					currentTime = parseInt(currentTime, 10);
				} catch (e) {
					currentTime = null;
					Debug.log('Could not parse currentTime: ' + currentTime);
				}
			}

			if (currentTime) {
				storedPosition = currentTime;
				_sendEvent('timeupdate', currentTime);
			}
		};

		window.IOSDeviceChromecastBridge.onChromecastPreload = function (preloadData) {
			if (typeof (preloadData) === 'string') {
				try {
					preloadData = JSON.parse(preloadData);
					preloadData.videoId = preloadData.videoId || null;
					preloadData.secondsLeft = parseInt(preloadData.secondsLeft, 10);
				} catch(e) {
					Debug.warn('onSetPreloadState: Could not parse preloadData: ' + preloadData);
					preloadData = {};
				}
			}
			Debug.log('onSetPreloadState videoId=%s secondsLeft=%s', preloadData.videoId, preloadData.secondsLeft);
			//ccUi.showPreload();
			_sendEvent('preload', preloadData);
		};

		function _sendEvent(eventType, data) {
			if (api.fire) {
				api.fire(eventType, data);
			}
		}

		function _handleStateUpdate(currentStatus, previousStatus, customData) {
			customData = customData || {};
			//CC Status -> Connecting. Loading = false. Ready = true. Playing = true.

			Debug.log('Status Update (%s) -> %s Loading = %s. Ready = %s. Playing = %s.', customData.eventMethod, currentStatus, _isLoading, api.state().ready, _isPlaying);
			if (currentStatus === CHROMECAST_STATUS.Connected && _isLoading) {
				Debug.log('Connected and loading');
				api.pause();
				ccUi.show(CHROMECAST_STATUS.Connected);
			} else if (currentStatus === CHROMECAST_STATUS.Connected && _isPlaying && previousStatus === CHROMECAST_STATUS.Connecting) {
				_internalLoadAndPlayEvent = false;
				Debug.log('Connected and playing');
				api.pause();

				if(api.state().ready && api.video && api.video().getCurrentTime) {
					_updateVideoStartPosition(api.video().getCurrentTime() || storedPosition);
				}
				NativeDispatcher.load();
				ccUi.show(CHROMECAST_STATUS.Connected);

				_sendEvent('ready', {
					externalUi: true
				});
			} else if (currentStatus === CHROMECAST_STATUS.Connected && _internalLoadAndPlayEvent && !_isPaused) {
				_internalLoadAndPlayEvent = false;
				Debug.log('Connected and ready, sending native load event');
				NativeDispatcher.load();

				_sendEvent('ready', {
					externalUi: true
				});

			} else if (currentStatus === CHROMECAST_STATUS.Connected && api.state().ready && !_isPaused) {
				_internalLoadAndPlayEvent = false;
				Debug.log('Connected and api-ready, show correct ui state');
				//NativeDispatcher.load();
				api.pause();
				ccUi.show(CHROMECAST_STATUS.Connected);

				_sendEvent('ready', {
					externalUi: true
				});

			} else if (currentStatus === CHROMECAST_STATUS.Connecting) {
				if(_isPlaying && !_isPaused) {
					Debug.log('Connecting and playing, pausing...');
					api.pause();
				}
				ccUi.show(CHROMECAST_STATUS.Connecting);
			} else if (currentStatus === CHROMECAST_STATUS.Disconnected && customData.eventMethod === STATUS_EVENT_METHOD.ENDED) {
				_internalLoadAndPlayEvent = false;
				var videoId = videoData.videoId;

				api.reset();
				_sendEvent('ready', {
					externalUi: false
				});

				Debug.log('Disconnected and ended cast at position: ' + customData.position);
				VideoAttributes.setStartPosition(Sizzle('video', api.element())[0], customData.position);
				api.load(videoId);
				// And then show controls
				api.fire('showControls', { shouldShow: true });
			} else if (currentStatus === CHROMECAST_STATUS.Disconnected && customData.eventMethod !== STATUS_EVENT_METHOD.ENDED) {
				_internalLoadAndPlayEvent = false;
			} else {
				Debug.log('Changed CC Status but not handled %s -> %s', customData.eventMethod, currentStatus);
			}
		}

		var oldSetPlayerState = window.IOSDeviceChromecastBridge.setChromecastPlayerState;
		window.IOSDeviceChromecastBridge.setChromecastPlayerState = function (playerState, customData) {
			if (typeof (customData) === 'string') {
				try {
					customData = JSON.parse(customData);
					customData.position = parseInt(customData.position, 10);
					customData.videoId = customData.videoId || null;
				} catch(e) {
					Debug.warn('Could not parse customData: ' + customData);
					customData = {};
				}
			}

			var currPlayerState = currentSessionPlayState();
			oldSetPlayerState(playerState);
			switch (playerState) {
				case CHROMECAST_PLAYER_STATE.PLAYING:
					if(currPlayerState !== playerState) {
						_sendEvent('playing');
					}
					ccUi.show(CHROMECAST_STATUS.Connected);
					break;
				case CHROMECAST_PLAYER_STATE.BUFFERING:
					if(currPlayerState !== playerState) {
						_sendEvent('buffering');
					}
					break;
				case CHROMECAST_PLAYER_STATE.LOADING:
					if(currPlayerState !== playerState) {
						_sendEvent('loading');
					}
					break;
				case CHROMECAST_PLAYER_STATE.PAUSED:
					if(currPlayerState !== playerState) {
						Debug.log('Player sent pause event');
						_sendEvent('pause');
					}
					break;
				case CHROMECAST_PLAYER_STATE.IDLE:
					// For some reason, idle gets called when switching video -- it should be handled by the app but fallback handled here!
					if(!_isLoading) {
						if (!customData.videoId || customData.videoId === videoData.videoId) {
							_sendEvent('pause');
							_sendEvent('ended', { videoId: customData.videoId });
						} else if (customData.videoId) {
							_sendEvent('ended', { videoId: videoData.videoId });
						} else if (!videoPlaylist || !videoPlaylist.items) {
							_sendEvent('ended', { videoId: videoData.videoId });
						}
					}
					break;
				case CHROMECAST_PLAYER_STATE.UNKNOWN:
					// Probably an error?
					Debug.log('unknownPlayerState State=%s isLoading=%s isPlaying=%s isPaused=%s', currentSessionStatus(), _isLoading, _isPlaying, _isPaused);
					break;
			}

			// Update this last
			_updateActivePlaylistVideoData(customData.videoId, customData.position);
		};

		function _updateActivePlaylistVideoData(videoId, position) {
			if (!videoPlaylist || videoPlaylist.items === 0) {
				Debug.log('_updateActivePlaylistVideoData: incorrect videoPlaylist', videoPlaylist);

				return;
			}

			if (!videoId || videoId === '' || videoId === videoData.videoId) {
				//Debug.log('_updateActivePlaylistVideoData: incorrect videoId (%s) or same as videoData %s', videoId, videoData.videoId);
				return;
			}

			videoData = initialVideoData();
			for(var i = 0; i < videoPlaylist.items.length; i++) {
				var playlistItem = videoPlaylist.items[i];
				if(playlistItem.videoId === videoId) {
					videoData.videoId = playlistItem.videoId;
					videoData.posterImage = playlistItem.poster;
					videoData.thumbnailImage = playlistItem.poster;
					videoData.position = position;
					// Updated videoData, send event
					_sendEvent('ready', {
						videoId: videoData.videoId,
						externalUi: true
					});
				}
			}

			if (videoData.videoId === '') {
				Debug.log('_updateActivePlaylistVideoData: Did not find videoPlaylistItem for ' + videoId);
			} else {
				Debug.log('_updateActivePlaylistVideoData: Found videoData for videoId = ' + videoData.videoId);
			}
		}

		function _updateVideoStartPosition(startPosition) {
			videoData.position = startPosition;

			if (videoPlaylist && videoPlaylist.items) {
				videoPlaylist.items[0].startPosition = videoData.position;
			}
		}

		function getPosterImage() {
			return videoData.posterImage || Sizzle('video', api.element())[0].getAttribute('poster') || api.config.defaultThumbnail;
		}

		function _buildVideodata(videoId, metadata) {
			// Reset first!
			videoData = initialVideoData();

			var posterImage = getPosterImage();

			videoData.videoId = videoId;
			videoData.thumbnailImage = posterImage;
			videoData.posterImage = posterImage;
			videoData.position = VideoAttributes.getStartPosition(Sizzle('video', api.element())[0]) || 0;
			videoData.metadata = metadata || {};

			Debug.log('videoData', videoData);
			_buildVideoPlaylist(videoId);
		}

		function _buildVideoPlaylist(videoId) {
			/**
			 See DEFAULT_VIDEO_PLAYLIST for required format
			 using getVideoPlaylistFunction
			 */
			if (typeof (VideoConfig.getVideoPlaylistFunction) === 'function') {
				var position = VideoAttributes.getStartPosition(Sizzle('video', api.element())[0]) || 0;
				videoPlaylist = VideoConfig.getVideoPlaylistFunction(videoId, position);
				Debug.log('videoPlaylist', videoPlaylist);
			}
		}

		function _getMetadataForIOSNativePlayer(videoId, onSuccess) {
			VideoConfig.metadataFetchFunction(videoId, (metadata) => {
					api.fire('metadata', metadata);
					if (api.data().inSweden !== undefined && !api.data().inSweden && (metadata.rights && metadata.rights.geoBlockedSweden)) {
						api.fire('error', {
							name: ErrorType.GEO_BLOCK_ERROR
						});

						return;
					}

					_buildVideodata(videoId, metadata);

					_sendEvent('ready', {
						videoId: videoData.videoId,
						externalUi: true
					});
					api.state().loading = false;
					api.state().ready = true;
					onSuccess(videoData);
				},
                (error, data) => {
					if (data) {
						api.fire('metadata', data);
					}
					api.fire('error', error);
				});
		}

		function _reset() {
			videoData = initialVideoData();
			videoPlaylist = null;
			_isLoading = false;
			_isPlaying = false;
			_isExternalUi = false;
			_isPaused = false;
			_internalLoadAndPlayEvent = false;

			ccUi.reset();
		}

		function _isConnected() {
			return sessionStorage.getItem(_sessionStorageKey) === CHROMECAST_STATUS.Connected;
		}

		function _isConnecting() {
            return sessionStorage.getItem(_sessionStorageKey) === CHROMECAST_STATUS.Connecting;
		}

		api.on(NAMESPACE + '.playing', function () {
			_isLoading = false;
			_isPlaying = true;
			_isPaused = false;
		});

		api.on(NAMESPACE + '.ready', function (event) {
			_isExternalUi = event.detail.externalUi;
			_isLoading = false;
			_isPaused = false;
		});

		api.on(NAMESPACE + '.pause', function () {
			_isPaused = true;
		});

		api.on(NAMESPACE + '.ended', function () {
			ccUi.hide();
			_isPlaying = false;
			_isPaused = false;
		});

		api.on(NAMESPACE + '.error', function () {
			if (_isConnected() || _isConnecting()) {
				domUtils.removeClass(api.element(), STATE_CLASS.error);
			} else {
				_isPlaying = false;
				_isPaused = false;
			}

		});

		api.on(NAMESPACE + '.controls', function (event) {
			if (event && event.detail && event.detail.visible !== undefined) {
				NativeDispatcher.controlsToggled(event.detail.visible);
			}
		});

		ccUi.build();

		api.filters.push({
			load: function (videoId) {
				Debug.log('Loading ios-chromecast, connected = ' + _isConnected());
				videoId = videoId || Sizzle('video', api.element())[0].getAttribute('data-video-id');
				if (_isConnected() || _isConnecting()) {

					if(videoData.videoId === videoId) {
						Debug.log('Already loading or will automatically load video with id = ' + videoId);
						ccUi.show(currentSessionStatus());

						return true;
					}

					_isLoading = true;
					_handleStateUpdate(currentSessionStatus());
					_buildVideoPlaylist(videoId);

					if (videoPlaylist) {
						api.state().ready = true;
						_internalLoadAndPlayEvent = true;
						_sendEvent('ready', {
							videoId: videoId,
							externalUi: true
						});

						api.play(videoId);

						return;
					}


					_getMetadataForIOSNativePlayer(videoId, function () {
						api.state().ready = true;

						_sendEvent('ready', {
							videoId: videoId,
							externalUi: true
						});

						if(api.config.autoplay) {
							api.play(videoId);
						}

					});

					return true;
				} else {
					_reset();
					api.once(NAMESPACE + '.metadata', function (metadata) {
						_buildVideodata(videoId, metadata.detail);
					});
				}

				return false;
			},
			play: function (videoId) {
				if (_isConnected()) {
					api.reset();

					NativeDispatcher.load();

					_sendEvent('ready', {
						videoId: videoId,
						externalUi: true
					});

					return true;
				} else if (_isConnecting()) {
					_sendEvent('ready', {
						videoId: videoId,
						externalUi: true
					});

					return true;
				}
			},
			reset: function () {
				if ((_isConnected() || _isConnecting())) {
					if (_isPlaying || _isLoading) {
						Debug.log('reset() - Ignored since were connected to chromecast and loading/playing video');

						return true;
					}
				} else {
					_reset();
				}
			},
			pause: function () {
				_isPaused = true;

				return _isConnected();
			},
			seek: function () {
				return _isConnected();
			},
			getVolume: function () {
				return _isConnected();
			},
			isMuted: function () {
				if (_isConnected()) {
					return false;
				}

				return null;
			},
			mute: function () {
				return _isConnected();
			},
			showCaptions: function () {
				return _isConnected();
			},
			setVolume: function () {
				return _isConnected();
			}
		});

	},

	destroy: function (api) {
		api.off(NAMESPACE + '.playing');
		api.off(NAMESPACE + '.pause');
		api.off(NAMESPACE + '.ready');
		api.off(NAMESPACE + '.ended');
		api.off(NAMESPACE + '.error');
		api.off(NAMESPACE + '.controls');

		var chromecastElement = Sizzle('.' + CLASSNAMES.chromecast, api.element())[0];
		if (chromecastElement) {
			api.element().removeChild(chromecastElement);
		}
	}
};



// WEBPACK FOOTER //
// ./src/js/plugins/ios-native-cc.js